export const profileSettingsES = {
  'Upon Login': 'Upon Login',
  'Open tabs from last session': 'Open tabs from last session',
  'Profile': 'Profile',
  'Cancel': 'Cancel',
  'Save': 'Save',
  Username: 'Username',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  Email: 'Email',
  Loading: 'Loading...',
  'Patients': 'Patients',
  'Pedigrees': 'Pedigrees',
  'Individuals': 'Individuals',
  'Invite Status': 'Invite Status',
  'Edit Questionnaires': 'Edit Questionnaires',
  'Email Templates': 'Email Templates',
  'Orders': 'Orders',
  'Letters': 'Letters',
  'Individual Spreadsheets': 'Individual Spreadsheets',
  'Pedigree Spreadsheets': 'Pedigree Spreadsheets',
  'Please wait': 'Please wait',
  'Change password': 'Change password',
  Current: 'Current',
  New: 'New',
  Confirm: 'Confirm',
  'Please enter new password': 'Please enter new password',
  "Confirmed password doesn't equal to new password": "Confirmed password doesn't equal to new password",
  'Failed to save profile': 'Failed to save profile',
  'Operation canceled': 'Operation canceled',
  'Please enter current password': 'Please enter current password',
  'The new password must be different from the current password': 'The new password must be different from the current password',
  'Please enter valid email': 'Please enter valid email',
  'Open the following tabs:': 'Open the following tabs:',
  'Patients': 'Patients',
  'Pedigrees': 'Pedigrees',
  'Individuals': 'Individuals',
  'Invite Status': 'Invite Status',
  'Edit Questionnaires': 'Edit Questionnaires',
  'Email Templates': 'Email Templates',
  'Orders': 'Orders',
  'Letters': 'Letters',
  'Individual Spreadsheets': 'Individual Spreadsheets',
  'Pedigree Spreadsheets': 'Pedigree Spreadsheets',
  Settings: 'Settings',
};